// Match.jsx
import React, { lazy, Suspense, useState, useRef, useCallback } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";
import MatchModal from "../../shared/Components/Modal/GameModal/MatchModal";
import MatchSettings from "../GameSettings/MatchSettings";

const MatchBody = lazy(() => import("./MatchBody"));

const Match = () => {
  const refetchRef = useRef(null);

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    modalTitle: "",
    modalContent: null,
    modalSize: "md",
  });

  const handleModal = (
    rowData,
    title = "",
    modalContent = MatchModal,
    modalSize = "md",
  ) => {
    setIsShow({
      isOpen: true,
      modalContent,
      modalTitle: title,
      rowData,
      modalSize,
    });
  };

  const handleMatchModal = useCallback((rowData) => {
    setIsShow({
      isOpen: true,
      modalContent: MatchSettings,
      modalTitle: "Match Settings",
      rowData,
      modalSize: "xxl",
    });
  });

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() => handleModal({}, "Create")}
        isBack={true}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <MatchBody
          onRefetchReady={(fn) => (refetchRef.current = fn)}
          onMatchSetting={handleMatchModal}
        />
      </Suspense>

      {isShow?.isOpen && (
        <CommonModal
          size={isShow.modalSize}
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              modalSize: "md",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              fetchData: () => refetchRef.current?.(),
            })}
        </CommonModal>
      )}
    </>
  );
};

export default Match;
